exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-pop-up-list{padding:20px}.app-pop-up-list .table-data-stage{margin-top:20px}.app-pop-up-list .table-data-stage .table-cell{vertical-align:middle;padding:10px}.app-pop-up-list .table-data-stage .table-cell[title]{height:100%;display:table-cell;text-overflow:clip}.app-pop-up-list .table-data-stage .image-box{width:80px}.app-pop-up-list .table-data-stage .image-box img{width:100%}.app-pop-up-list .table-data-stage .effective-time{display:inline-block;border-bottom:1px solid #d6d6d6;padding-bottom:10px;margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/appBackend/components/page/configPush/app-pop-up/app-pop-up-list/app-pop-up-list.scss
// module id = 525
// module chunks = 2